export default __webpack_public_path__ + "static/media/plus_white.25007774.svg";